const html = document.documentElement
const { body } = document

export { html, body }
